import { SignInPage } from '@backstage/core-components';
import { githubAuthApiRef } from '@backstage/core-plugin-api';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

export const AppSignInPage: ExtensionDefinition = SignInPageBlueprint.make({
  params: {
    loader: async () => props => (
      <SignInPage
        {...props}
        title="Traffic Solvers"
        provider={{
          id: 'github-auth-provider',
          title: 'GitHub',
          message: 'Sign in with your Traffic Solvers GitHub account',
          apiRef: githubAuthApiRef,
        }}
      />
    ),
  },
});
